module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9558.63a33579.jpg";